var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAltBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 27,
    height: 20,
    rx: 4,
    fill: "#404040"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.752 15L7.328 5.2H10.548L13.124 15H11.22L10.688 12.844H7.188L6.656 15H4.752ZM7.622 11.136H10.254L9.064 6.362H8.812L7.622 11.136ZM14.353 15V5.2H16.117V15H14.353ZM20.7318 15C20.2745 15 19.9011 14.86 19.6118 14.58C19.3318 14.2907 19.1918 13.908 19.1918 13.432V9.512H17.4558V8.056H19.1918V5.9H20.9558V8.056H22.8598V9.512H20.9558V13.124C20.9558 13.404 21.0865 13.544 21.3478 13.544H22.6918V15H20.7318Z",
    fill: "#E5E5E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAltBtn);
export default __webpack_public_path__ + "static/media/alt-btn.9f8f1a24121bb479a16722c194ed7e0d.svg";
export { ForwardRef as ReactComponent };